export default __webpack_public_path__ + "assets/clever-d3c704d.svg";